import { gql } from '@apollo/client'
import { useActionMutation } from '@ztechapps/common.hook'
import type { Chat, MergeChatArgs } from '@ztechapps/common.contract'

export const mergeChatQuery = gql`
  mutation mergeChat($input: MergeChatArgs!) {
    mergeChat(input: $input) {
      _id
      externalId
    }
  }
`

/**
 * Merges the source conversation into the target via the channel-aware mergeChat mutation.
 * Returns the standard useActionMutation tuple — call `merge({ sourceChatId, targetChatId })`.
 */
export const useMergeChat = () => useActionMutation<Chat, MergeChatArgs>({ query: mergeChatQuery })
